import React, { Component } from "react";
import { I18n } from "react-redux-i18n";
import EditorLabel from "editor/components/EditorLabel";

import {
  TextareaWrapper,
  TextareaContainer,
  TextareaInput,
  CharacterSpan,
  UsageMessage,
  PageTitle,
  SvgCopy,
} from "./styles";

class WhatsappMessage extends Component {
  handleChange = (event) => {
    const { name, updaterFn } = this.props;
    const { value } = event.target;
    updaterFn({
      prop: name,
      value,
    });
  };

  render() {
    const { config, label, locale, currentValue } = this.props;
    return (
      <TextareaWrapper>
        <EditorLabel>{label[locale]}</EditorLabel>
        <TextareaContainer>
          <TextareaInput
            maxLength={config.maxCharacters}
            onChange={this.handleChange}
            value={currentValue}
          >
            {currentValue}
          </TextareaInput>
          <CharacterSpan>{`${currentValue ? currentValue.length : 0}/${config.maxCharacters}`}</CharacterSpan>
        </TextareaContainer>
        <UsageMessage>
          {I18n.t("editPanel.textarea.usageMessage")}
          <PageTitle>{` {page_title} `}</PageTitle>
          <SvgCopy
            width="6"
            height="8"
            viewBox="0 0 6 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            onClick={() => {
              navigator.clipboard.writeText("{page_title}");
            }}
          >
            <path
              d="M5.82733 1.60642L4.873 0.596087C4.81629 0.538935 4.74876 0.493644 4.67436 0.462855C4.59997 0.432066 4.52018 0.416394 4.43967 0.416754H1.77767C1.61567 0.416931 1.46037 0.48136 1.34582 0.595907C1.23127 0.710453 1.16684 0.865761 1.16667 1.02775V1.58342H0.611C0.449007 1.5836 0.293699 1.64803 0.179153 1.76257C0.0646062 1.87712 0.000176463 2.03243 0 2.19442V6.97242C0.000176463 7.13441 0.0646062 7.28972 0.179153 7.40427C0.293699 7.51881 0.449007 7.58324 0.611 7.58342H4.22233C4.38433 7.58324 4.53963 7.51881 4.65418 7.40427C4.76873 7.28972 4.83316 7.13441 4.83333 6.97242V6.41675H5.389C5.55099 6.41658 5.7063 6.35215 5.82085 6.2376C5.93539 6.12305 5.99982 5.96775 6 5.80575V2.03342C6.00076 1.95438 5.9859 1.87597 5.95627 1.80269C5.92664 1.72941 5.88282 1.66271 5.82733 1.60642ZM4 6.91675H0.833333C0.789131 6.91675 0.746738 6.89919 0.715482 6.86794C0.684226 6.83668 0.666667 6.79429 0.666667 6.75009V2.41675C0.666667 2.37255 0.684226 2.33016 0.715482 2.2989C0.746738 2.26765 0.789131 2.25009 0.833333 2.25009H1.08333C1.10543 2.25009 1.12663 2.25887 1.14226 2.2745C1.15789 2.29012 1.16667 2.31132 1.16667 2.33342V5.80575C1.16667 5.9678 1.23104 6.12321 1.34562 6.2378C1.46021 6.35238 1.61562 6.41675 1.77767 6.41675H4.08333C4.10543 6.41675 4.12663 6.42553 4.14226 6.44116C4.15789 6.45679 4.16667 6.47799 4.16667 6.50009V6.75009C4.16667 6.79429 4.14911 6.83668 4.11785 6.86794C4.0866 6.89919 4.0442 6.91675 4 6.91675ZM5.16667 5.75009H2C1.9558 5.75009 1.9134 5.73253 1.88215 5.70127C1.85089 5.67002 1.83333 5.62762 1.83333 5.58342V1.25009C1.83333 1.20588 1.85089 1.16349 1.88215 1.13224C1.9134 1.10098 1.9558 1.08342 2 1.08342H4.345C4.36767 1.08346 4.39009 1.08812 4.41089 1.09712C4.4317 1.10611 4.45045 1.11926 4.466 1.13575L5.28767 2.00575C5.31692 2.03664 5.33326 2.07754 5.33333 2.12009V5.58342C5.33333 5.62762 5.31577 5.67002 5.28452 5.70127C5.25326 5.73253 5.21087 5.75009 5.16667 5.75009Z"
              fill="#50AFF4"
            />
          </SvgCopy>
        </UsageMessage>
      </TextareaWrapper>
    );
  }
}

export default WhatsappMessage;
